import Login from '../components/routes/auth/Login.vue'
import PasswordSet from '../components/routes/auth/PasswordSet.vue'

import Forgot from '../components/routes/auth/PasswordForgot.vue'
import RegistrationConfirm from '../components/routes/auth/RegistrationConfirm.vue'
import EmailUpdateConfirm from '../components/routes/auth/EmailUpdateConfirm.vue'

import DataPrivacy from '../components/routes/website/DataPrivacy'
import Imprint from '../components/routes/website/Imprint'

// all routes in this list receive a flag that they are not protected by auth
const unprotectedRoutes = [{
  name: 'home',
  path: '/',
  component: Login
},
{
  name: 'dataPrivacy',
  path: '/datenschutz',
  component: DataPrivacy
},
{
  name: 'imprint',
  path: '/impressum',
  component: Imprint
},
{
  name: 'login',
  path: '/login',
  component: Login
},
{
  name: 'registrationConfirm',
  path: '/registration/confirm',
  component: RegistrationConfirm
},
{
  name: 'resetPassword',
  path: '/password/reset',
  component: PasswordSet
},
{
  name: 'setPassword',
  path: '/password/set',
  component: PasswordSet
},
{
  name: 'forgotPassword',
  path: '/password/forgot',
  component: Forgot
},
{
  name: 'emailUpdateConfirmation',
  path: '/email-update/confirm',
  component: EmailUpdateConfirm
}
].map(route => {
  route.meta = {
    ignoreAuth: true
  }
  return route
})

export default unprotectedRoutes
